import {Component, Output, EventEmitter, Input} from '@angular/core';
import {MessageService} from 'primeng/api';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import {HttpClient} from '@angular/common/http';



export class FileInfo {
  name: string;
  file: File;
  documentType: string;
  fileType: string;
  entityType: string;
  objectId: string
  documentNumber: string = null;
  constructor() {

  }
}

export const constants = {
  documentTypes : {
    MemberRegistration : 'Member Registration' ,
    ID : 'ID'
  }
}

@Component({
  selector: 'copart-upload-document',
  templateUrl: './upload-document.component.html',
  styleUrls: ['./upload-document.component.scss'],
  providers: [MessageService]
})

export class UploadDocumentComponent {
  @Input() docType: string;
  @Input() entityType: string;
  @Input() initialData: any;
  @Output() sharedVarChange: EventEmitter<any> = new EventEmitter();
  @Output() submitDocs: EventEmitter<any> = new EventEmitter();
  newDocument: any = [];
  constructor(private http: HttpClient) {}




onFileUpload(event: any) {
  this.newDocument = [];
  const fileInfo: FileInfo = new FileInfo();
  fileInfo.name = event.target.files[0].name;
  fileInfo.file = event.target.files[0];
  fileInfo.fileType = event.target.files[0].type;
  fileInfo.entityType = this.entityType;
  fileInfo.documentType = this.docType;
  fileInfo.objectId = this.initialData.companyId;
        // TODO Have to Get All DocTypes from a constants file/ Reference Data
  if (this.docType === constants.documentTypes.MemberRegistration) {
        fileInfo.documentNumber = this.initialData.vatId;
        }
  this.newDocument.push(fileInfo);
  this.sharedVarChange.emit();
      }


  removeSelectedFile(inputFile) {
      this.newDocument = [];
      this.sharedVarChange.emit();
      inputFile.value = ''  
  }
  onSuccess() {
    this.submitDocs.emit('SUCCESS');
  }

  submitDocumentPayload( uploadedFiles: any, url: string) {
    this.submitDocs.emit(true);
    const formData = new FormData();
    for (let i = 0; i < uploadedFiles.length; i++) {
        formData.append('file'  , uploadedFiles[i].file );
        delete uploadedFiles[i].file;
        const name = uploadedFiles[i].name.replace(/ /g, '_');
        formData.append(name , JSON.stringify(uploadedFiles[i]));
    }

    this.http.post(url, formData).subscribe((resp: any)  => {
       let status = true;
       if (isNotNullOrUndefined(resp)) {
        resp.forEach((fileStatus: any) => {
          status = status && (Object.values(fileStatus)[0] === 'SUCCESS');
        });
        if (status) {
        this.onSuccess();
        } else {
          this.submitDocs.emit('FAILURE');
        }
      }
    },  err => {
      this.submitDocs.emit('FAILURE');
    });

  }

}


